import React from 'react';
import { string } from 'prop-types';
import cx from 'classnames';

import useStyles from 'hooks/useStyles';

import styles from './HtmlRenderer.scss';

const HtmlRenderer = ({ title, html, className }) => {
  useStyles(styles);
  return (
    <section className={cx(styles.root, className)}>
      <h2 className={styles.title}>{title}</h2>
      <div
        className={styles.content}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </section>
  );
};

HtmlRenderer.propTypes = {
  title: string.isRequired,
  html: string.isRequired,
  className: string,
};

HtmlRenderer.defaultProps = {
  className: '',
};

export default HtmlRenderer;
